import { EDISStatus } from 'sharedweb/app.structs';

export const EDIS_NOTE = 'CDSL authentication could not be done for all holdings, please check holdings book for more info';
export const EDIS_STATUS_STRING = 'CDSL PIN verification is';
export const PLEDGE_STATUS_STRING = 'Pledge request is';

export const EDIS_AUTHORIZE_FAILED_CUSTOM_TOAST = (rejectionText: string) => `${rejectionText}
                                                                <div class="decoration-underline font-bold margin-8-top">
                                                                    Please click here to Authorise Holding
                                                                </div>`;

export function getEDISStatusString(base: string, status: EDISStatus) {
    switch (status) {
        case EDISStatus.SUCCESS:
            return `${base} successful.`;

        case EDISStatus.FAILURE:
            return `${base} unsuccessful, kindly retry after some time.`;
    }
}

export function getCDSLExtendedInfo() {
    return ['EDIS (Electronic Delivery Instruction Slip) is a facility provided to user who ' +
        'wish to sell shares but have not couriered a physical copy of the POA (Power Of Attorney).',
    'Once you click \'Sell\' you\'ll be prompted to give consent to sell your shares. ' +
    'An CDSL PIN will be sent to your registered email id and phone number.',
        'You will be redirected to CDSL website to enter the PIN.',
    'If you do not wish to do this activity then you will need to courier the physical copy ' +
    'of the POA form to our corporate office address.'];
}

export const MAX_EDIS_HOLDINGS_ACTION_WARNING = '*Max 100 rows can be selected';

export const NO_EDIS_TO_AUTHORIZE = 'Please select Holding(s) to authorize.';
export const NO_EDIS_TO_UNAUTHORIZE = 'Please select Holding(s) to unauthorize.';

export const REGENERATE_SUCCESS = 'TPIN successfully sent to registered Email and mobile number';
export const REGENERATE_FAILURE = 'Error encountered while regenerating the TPIN';
export const PLEDGING_VALIDATION_ERROR = 'Quantity should be greater than 0';
export const PLEDGING_VALIDATION_ERROR_MF = 'Please select at least one mutual fund to pledge';
export const EDIS_VALIDATION_ERROR = 'Please enter a valid quantity.';
export const PLEDGE_QUANTITY_CONFIRMATION = 'Pledgeable quantity has been updated, please re-verify your input.'
export const PLEDGE_OTP_VERIFIED = 'Pledge Request Submitted Successfully';
export const PLEDGE_OTP_VERIFIED_DISPLAY_TEXT = 'Your pledge request submitted successfully. We\'ll update you soon.';
export const PLEDGE_SUCCESS_DESCRIPTION = 'Your pledge request is accepted and your available margin is updated for following holdings.';
export const PLEDGE_FAILURE_DESCRIPTION = `Your pledge request couldn't be processed due to insufficient balance for following holdings.`;
export const PLEDGE_OVERDUE_DESCRIPTION = `Your pledge quantity is awaiting pledge confirmation and will remain temporarily blocked until a status update is received by 6:30 PM.`;